/* eslint-disable no-console */
/**
 * 构建版本提示：在浏览器控制台打印当前部署版本，便于线上排查
 * 注意：必须放在 disableLogs 之前执行，否则 release 环境下 console 会被屏蔽
 */
export default function () {
  if (typeof window === 'undefined') return

  const version = process.env.BUILD_VERSION || 'unknown'
  const runEnv = process.env.RUN_ENV || 'dev'

  // 暴露到全局，方便线上排查
  window.__BUILD_VERSION__ = version

  const badgeStyle = [
    'background:#5A47EE',
    'color:#fff',
    'padding:2px 8px',
    'border-radius:3px',
    'font-size:12px',
    'font-weight:bold'
  ].join(';')

  console.log(
    `%c KOP ${runEnv} %c version: ${version}`,
    badgeStyle,
    'color:#5A47EE;font-weight:bold'
  )
}
